module.exports = __webpack_public_path__ + "img/waiting-back.e9b135c0.svg";